/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type EmployeeApplicationUsageLineChartQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['UUID']['input'];
  dateFrom?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  dateTo?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  categoryIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['UUID']['input']>> | Types.InputMaybe<Types.Scalars['UUID']['input']>>;
  applicationResourceId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type EmployeeApplicationUsageLineChartQuery = { __typename: 'Query', clientEmployeeApplicationInteractions?: { __typename: 'ClientEmployeeApplicationInteractionsResultType', dailySummary: Array<{ __typename: 'ClientEmployeeInteractionSummaryType', date: any, uniqueResourceGroups: number, uniqueApplications: number }> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const EmployeeApplicationUsageLineChartDocument = new TypedDocumentString(`
    query EmployeeApplicationUsageLineChart($employeeId: UUID!, $dateFrom: Date, $dateTo: Date, $categoryIds: [UUID], $applicationResourceId: UUID) {
  clientEmployeeApplicationInteractions(
    clientEmployeeId: $employeeId
    dateFrom: $dateFrom
    dateTo: $dateTo
    categoryIds: $categoryIds
    applicationResourceId: $applicationResourceId
  ) {
    dailySummary {
      date
      uniqueResourceGroups
      uniqueApplications
    }
  }
}
    `);

export const useEmployeeApplicationUsageLineChartQuery = <
      TData = EmployeeApplicationUsageLineChartQuery,
      TError = unknown
    >(
      variables: EmployeeApplicationUsageLineChartQueryVariables,
      options?: Omit<UseQueryOptions<EmployeeApplicationUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmployeeApplicationUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmployeeApplicationUsageLineChartQuery, TError, TData>(
      {
    queryKey: ['EmployeeApplicationUsageLineChart', variables],
    queryFn: fetcher<EmployeeApplicationUsageLineChartQuery, EmployeeApplicationUsageLineChartQueryVariables>(EmployeeApplicationUsageLineChartDocument, variables),
    ...options
  }
    )};

useEmployeeApplicationUsageLineChartQuery.getKey = (variables: EmployeeApplicationUsageLineChartQueryVariables) => ['EmployeeApplicationUsageLineChart', variables];

export const useInfiniteEmployeeApplicationUsageLineChartQuery = <
      TData = InfiniteData<EmployeeApplicationUsageLineChartQuery>,
      TError = unknown
    >(
      variables: EmployeeApplicationUsageLineChartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmployeeApplicationUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmployeeApplicationUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EmployeeApplicationUsageLineChartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmployeeApplicationUsageLineChart.infinite', variables],
      queryFn: (metaData) => fetcher<EmployeeApplicationUsageLineChartQuery, EmployeeApplicationUsageLineChartQueryVariables>(EmployeeApplicationUsageLineChartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEmployeeApplicationUsageLineChartQuery.getKey = (variables: EmployeeApplicationUsageLineChartQueryVariables) => ['EmployeeApplicationUsageLineChart.infinite', variables];


useEmployeeApplicationUsageLineChartQuery.fetcher = (variables: EmployeeApplicationUsageLineChartQueryVariables) => fetcher<EmployeeApplicationUsageLineChartQuery, EmployeeApplicationUsageLineChartQueryVariables>(EmployeeApplicationUsageLineChartDocument, variables);
